import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type ElfLoanAccountOnFileDialogProps = {
  open: boolean;
  onClose: () => void;
  borrowerName?: string;
};

const ElfLoanAccountOnFileDialog: React.FC<ElfLoanAccountOnFileDialogProps> = ({
  open,
  onClose,
  borrowerName,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Account on file</DialogTitle>
      <DialogContent dividers>
        <Alert severity="info" sx={{ mb: 2 }}>
          Saved payment methods (vault + PayPal) are not available yet. This
          will let borrowers store a card or bank account for scheduled
          payments.
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {borrowerName
            ? `No saved payment methods for ${borrowerName}.`
            : 'No saved payment methods on file.'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Future integration will use the peo-lockdown vault for PCI-safe
          storage and PayPal for recurring profiles.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" disabled>
          Add payment method
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ElfLoanAccountOnFileDialog;
